module.exports = __webpack_public_path__ + "img/shrewd-save-2.ff810649.webp";